import { clearFilters, filterValues } from "#/admin/legacy/page-builder/search-filters.js";
import { whenSelectsReady } from "#/admin/legacy/sp-select/when-selects-ready.js";

(function (event) {
  /*
   * A generalized solution for adding search to a page.
   *
   * To add a search to the page, first create an instance of the
   * Search class then implement the matches method.
   *
   * Then initialize an instance of the search by passing a selector
   * for the input, a selector for the container where the results are
   * displayed, a selector for where to display a message, and the data
   * to be searched in.
   *
   * The Search class assumes each datum of your data has an ID, it also
   * needs a way to link each piece of data to a dom element so it can show/hide
   * it as you search. So you must add a data-search-lookup="{{ id }}" attribute
   * to each element in the searchable container where {{ id }} maps to the id
   * property of the data
   *
   * As a user searches it will throw off events, one for when the search is done
   * and another when the dom is finished updating. pb:search and pb:search:update.
   * You can subscribe to these events using the global event object.
   *
   * As the search results are updated in the dom, it will add a data-search-match
   * property to each result, setting it to true or false. You can use that to hide/show
   * the result however you want using CSS.
   *
   * See an example of implementing search: SharedComponentSearch
   */

  function Search(input, filters, results, message, data) {
    function search(value) {
      search.value = value || search.value || "";
      var data = search.data || [];

      event.trigger("pb:search");

      return data.filter(search.matcher);
    }

    // overload this template method to implement actual sort functionality.
    search.sorter = function () {
      return function () {
        return 0;
      };
    };

    search.matcher = function (data) {
      return true;
    };

    search.$input = jQuery(input);
    search.$filters = jQuery(filters);
    search.$results = jQuery(results);
    search.$message = jQuery(message);
    search.data = data || [];
    search.value = search.$input.val() || "";

    search.getFilterValues = function () {
      return filterValues(search.$filters);
    };

    // this is a template method that should be implemented in specific
    // search implementations, since it's up to those implementations to have
    // an awareness of the related ui elements.
    search.updateFilterStatus = function () {};

    search.bind = function (input, filters, results, message, data) {
      var $input = (search.$input = jQuery(input)),
        $filters = (search.$filters = jQuery(filters)),
        $results,
        $message;

      if (results) {
        $results = search.$results = jQuery(results);
      }

      if (message) {
        $message = search.$message = jQuery(message);
      }

      search.data = data || search.data;
      $input.on("keyup", function (event) {
        search.value = this.value;
        var matches = search();
        search.update(matches);
      });

      whenSelectsReady($filters.filter("sp-select").toArray(), function initializeFilters() {
        search.update(search());
        search.updateFilterStatus();
      });

      // update search results when filters change.
      $filters.on("change", function (e) {
        search.update(search());
        search.updateFilterStatus();
      });
    };

    search.update = function (matches) {
      var data = search.data,
        unmatches = data.filter(function (datum) {
          return matches.indexOf(datum) === -1;
        });

      // apply the appropriate sorting method to these results. Reinsertion of complex SVG elements into the DOM is slow,
      // so avoid re-sorting them if they're already in the correct order.
      var sortChanged = this.sort != this.renderedSort;
      this.renderedSort = this.sort;

      if (sortChanged) {
        matches.sort(search.sorter());
      }

      var elements = [];

      matches.forEach(function (match) {
        // mark the element as a match.
        // we assume the data has an ID property
        var element = search.$results.find('[data-search-lookup="' + match.id + '"]')[0];
        elements.push(element);
        element.dataset.searchMatch = true;
      });

      unmatches.forEach(function (unmatch) {
        // mark the element as a non-match.
        var element = search.$results.find('[data-search-lookup="' + unmatch.id + '"]')[0];
        elements.push(element);
        element.dataset.searchMatch = false;
      });

      if (message) {
        if (matches.length < 1) {
          search.$message.addClass("searchMessage-show");
        } else {
          search.$message.removeClass("searchMessage-show");
        }
      }

      // Append in sort order
      if (sortChanged) {
        search.$results.append(elements);
      }

      event.trigger("pb:search:update");
    };

    return search;
  }

  function SharedComponentSearch() {
    var search = Search.apply(null, arguments);

    // set the sort value and update the ui.
    search.setSort = function (sort) {
      // set the sort value.
      search.sort = sort;

      // update the label.
      var selectedSort = jQuery("#shared-components-sort [data-sort='" + sort + "']");
      var dropDown = selectedSort.closest(".dropdown");
      var sortLabel = dropDown.find(".button-text");
      sortLabel.text("Sort by: " + selectedSort.text());

      // update the selected item in the dropdown.
      var icon = dropDown.find(".dropdown-item-icon").detach();
      dropDown.find(".dropdown-item.selected-item").removeClass("selected-item");
      selectedSort.addClass("selected-item");
      selectedSort.prepend(icon);

      // update the search results.
      search.update(search());
    };

    // we're overloading the original bind method to add additional
    // functionality related to this specific search/filter implementation.
    var bind = search.bind;
    search.bind = function (input, filters, results, message, data) {
      // call the original bind first.
      bind(input, filters, results, message, data);

      // allow users to reset all filter selections.
      jQuery("#shared-components-search-and-filter button.reset").on("click", function (e) {
        clearFilters(search.$filters);
        search.update(search());
        search.updateFilterStatus();
      });

      // this just closest the expanded popover.
      jQuery("#shared-components-search-and-filter button.confirm").on("click", function (e) {
        jQuery("#shared-components-search-and-filter .filters-button").trigger("click");
      });

      // add callbacks for sort options.
      jQuery("#shared-components-sort [data-sort]").on("click", function (e) {
        search.setSort(jQuery(e.target).attr("data-sort"));
      });
    };

    // sort by date created in descending order.
    search.sortByDateCreated = function (a, b) {
      var dateA = Date.parse(a.created_at_timestamp),
        dateB = Date.parse(b.created_at_timestamp);
      if (dateA > dateB) {
        return -1;
      } else if (dateA < dateB) {
        return 1;
      }
      return 0;
    };

    search.sortByAlphabetical = function (a, b) {
      var nameA = a.name.toLowerCase().trim(),
        nameB = b.name.toLowerCase().trim();
      if (nameA > nameB) {
        return 1;
      } else if (nameA < nameB) {
        return -1;
      }
      return 0;
    };

    search.sortByMostUsed = function (a, b) {
      var countA = a.component_assignments_count,
        countB = b.component_assignments_count;
      if (countA > countB) {
        return -1;
      } else if (countA < countB) {
        return 1;
      }
      return 0;
    };

    // sort by date modified in descending order.
    search.sortByRecentlyModified = function (a, b) {
      var dateA = Date.parse(a.updated_at_timestamp),
        dateB = Date.parse(b.updated_at_timestamp);
      if (dateA > dateB) {
        return -1;
      } else if (dateA < dateB) {
        return 1;
      }
      return 0;
    };

    search.sorter = function () {
      if (search.sort == "recently-modified") {
        return search.sortByRecentlyModified;
      } else if (search.sort == "alphabetical") {
        return search.sortByAlphabetical;
      } else if (search.sort == "most-used") {
        return search.sortByMostUsed;
      } else {
        return search.sortByDateCreated;
      }
    };

    search.matcher = function (component) {
      var value = search.value.toLowerCase().replace(/[^a-zA-Z\d]/g, ""),
        name = component.name || "";
      name = name.toLowerCase().replace(/[^a-zA-Z\d]/g, "");

      // grab any selected filter values.
      var filterValues = search.getFilterValues();

      // filter by search text
      if (value.length > 0 && name.indexOf(value) === -1 && !component.id.toString().startsWith(value)) {
        return false;
      }

      // filter for component type.
      if (filterValues.type && component.template != filterValues.type) {
        return false;
      }

      // filter for non-ctas.
      if (filterValues.behavior == "non_ctas" && component.role != "standard-component") {
        return false;
      }

      // filter for ctas.
      if (filterValues.behavior == "ctas" && component.role != "primary-cta" && component.role != "secondary-cta") {
        return false;
      }

      // filter for labels.
      if (filterValues.label && !_.contains(component.label_ids, parseInt(filterValues.label))) {
        return false;
      }

      return true;
    };

    search.updateFilterStatus = function () {
      var filtersButton = jQuery("#shared-components-search-and-filter .filters-button");

      // if there are filters currently set ..
      if (_.keys(search.getFilterValues()).length > 0) {
        filtersButton.addClass("primary");
      } else {
        filtersButton.removeClass("primary");
      }
    };

    return search;
  }

  // export
  Sparkle.PageBuilder.Helpers = _.extend(
    {
      Search: Search,
      SharedComponentSearch: SharedComponentSearch,
    },
    Sparkle.PageBuilder.Helpers,
  );
})(Sparkle.PageBuilder.Helpers.Event);
